var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCopyText = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.061,
    height: 25.065,
    viewBox: "0 0 25.061 25.065",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8079",
    "data-name": "Group 8079",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9988",
    "data-name": "Rectangle 9988",
    width: 25.061,
    height: 25.065,
    rx: 2,
    transform: "translate(0 0)",
    fill: "#e5eaed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "subtract",
    d: "M0,1.75A1.75,1.75,0,0,1,1.75,0h7A1.75,1.75,0,0,1,10.5,1.75V3.5h1.75A1.75,1.75,0,0,1,14,5.25v7A1.75,1.75,0,0,1,12.25,14h-7A1.75,1.75,0,0,1,3.5,12.25V10.5H1.75A1.75,1.75,0,0,1,0,8.75ZM1.75.875a.875.875,0,0,0-.875.875v7a.875.875,0,0,0,.875.875h7a.875.875,0,0,0,.875-.875v-7A.875.875,0,0,0,8.75.875Z",
    transform: "translate(5.53 5.532)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCopyText);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNS4wNjEiIGhlaWdodD0iMjUuMDY1IiB2aWV3Qm94PSIwIDAgMjUuMDYxIDI1LjA2NSI+CiAgPGcgaWQ9Ikdyb3VwXzgwNzkiIGRhdGEtbmFtZT0iR3JvdXAgODA3OSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAwKSI+CiAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlXzk5ODgiIGRhdGEtbmFtZT0iUmVjdGFuZ2xlIDk5ODgiIHdpZHRoPSIyNS4wNjEiIGhlaWdodD0iMjUuMDY1IiByeD0iMiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAwKSIgZmlsbD0iI2U1ZWFlZCIvPgogICAgPHBhdGggaWQ9InN1YnRyYWN0IiBkPSJNMCwxLjc1QTEuNzUsMS43NSwwLDAsMSwxLjc1LDBoN0ExLjc1LDEuNzUsMCwwLDEsMTAuNSwxLjc1VjMuNWgxLjc1QTEuNzUsMS43NSwwLDAsMSwxNCw1LjI1djdBMS43NSwxLjc1LDAsMCwxLDEyLjI1LDE0aC03QTEuNzUsMS43NSwwLDAsMSwzLjUsMTIuMjVWMTAuNUgxLjc1QTEuNzUsMS43NSwwLDAsMSwwLDguNzVaTTEuNzUuODc1YS44NzUuODc1LDAsMCwwLS44NzUuODc1djdhLjg3NS44NzUsMCwwLDAsLjg3NS44NzVoN2EuODc1Ljg3NSwwLDAsMCwuODc1LS44NzV2LTdBLjg3NS44NzUsMCwwLDAsOC43NS44NzVaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg1LjUzIDUuNTMyKSIvPgogIDwvZz4KPC9zdmc+Cg==";